export default __webpack_public_path__ + "static/media/Screenshot.cc13e2d6.png";